import Swal from "sweetalert2"
import axios from "axios"
import Cookies from "js-cookie"

const paths = [
    "/windev/index.html",
    "/webdev/index.html",
    "/windevmobile/index.html",
    "/index.html"
]

const path = document.querySelector('body').getAttribute('data-name') ?? false
if(path && paths.includes(path))
{
    document.addEventListener('DOMContentLoaded', function() {
        setTimeout(showPopupEmail, 10000);
    });

    function showPopupEmail ()
    {
        var debug            = false;

        window.addEventListener('scroll', function() {

            var cookieEmailModal = Cookies.get('email-modal');

            //Si pas de cookie, ou alors en mode debug
            if(!cookieEmailModal || cookieEmailModal && debug)
            {
                if((window.innerHeight + window.scrollY) > (document.body.offsetHeight / 2))
                {
                    //Création de la modal
                    Swal.fire({
                        width: '48rem',
                        title: '<strong>Restez informé !</strong>',
                        icon: 'info',
                        html: 'Recevez en exclusivité les dernières actualités sur WINDEV. <br /> Indiquez simplement votre email.' +
                            '<br /><br /><form id="FormEmailModal" action="https://www.sitedynamique.fr/prospect.awp" method="post">' +
                            '<input type="hidden" name="type" value="prospect">' +
                            '<input type="hidden" name="form" value="prospect">' +
                            '<input type="hidden" name="go" value="https://pcsoft.fr/email-inscription-ok.html">' +
                            '<input name="EMAIL" id="FormEmailModalInputEmail" type="email" placeholder="Saisissez votre email" class="swal2-input">' +
                            '</form>'+
                            '<span style="font-size: 0.9rem;">Votre adresse mail ne sera partagée avec personne. <br />' +
                            'Nous conservons vos données confidentielles.</span>',
                        showCloseButton: true,
                        showCancelButton: true,
                        confirmButtonText: 'Valider',
                        cancelButtonText: 'Fermer',
                        reverseButtons: true,
                        showLoaderOnConfirm: true,
                        // showClass: {
                        //     popup: 'animate__animated animate__slideInUp'
                        // },

                        inputValidator(inputValue) {
                            if(!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(inputValue)) {
                                return 'Vous devez saisir une adresse email valide'
                            }
                        },

                        preConfirm() {

                            var email = $("#FormEmailModalInputEmail").val();
                            if(!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email))
                            {
                                Swal.showValidationMessage("Vous devez saisir une adresse email valide.");
                                return;
                            }

                            const data = new FormData(document.querySelector('#FormEmailModal'));
                            axios.post("https://www.sitedynamique.fr/prospect.awp", data)
                                // .then(function(r) { console.log('r', r) })
                            //.catch(function(e) { console.log('e', e)} )

                            //on poste le formulaire
                            Cookies.set('email-modal', 'none', {expires: 365});
                            //$("#FormEmailModal").submit();
                        },
                    }).then(function(isConfirm) {

                        if(!isConfirm || isConfirm.dismiss)
                        {
                            Cookies.set('email-modal', 'none', {expires: 1})
                        }
                    })
                }
            }
        });
    }
}




